import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

// Global so the command menu can open the dialog from any page.
export const isCreateProjectDialogOpenState = createAtomState<boolean>({
  key: 'isCreateProjectDialogOpenState',
  defaultValue: false,
});
